import Bus from 'lib/bus';

export default function DetectTouchDevice() {
    const bus = Bus();
    let touch = false;

    constructor();

    function constructor() {
        add_events();
    }

    function add_events() {
        window.addEventListener('touchstart', on_touch_start);
    }

    function remove_events() {
        window.removeEventListener('touchstart', on_touch_start);
    }

    function on_touch_start() {
        remove_events();

        touch = true;

        bus.emit('is-touch');
    }

    function is_touch_device() {
        return touch;
    }

    function destroy() {
        remove_events();
        bus.destroy();
        touch = null;
    }

    return {
        is_touch_device,
        on: bus.on,
        off: bus.off,
        destroy
    }
}